import { Outlet } from "react-router-dom";
import { MainFrame } from "@/common/MainFrame";

export function ModuleCustomerFile() {
    return <MainFrame>
        <Outlet/>
    </MainFrame>;
}
